import React from 'react';

const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
};

const HealthTrendsDashboard = () => {
    const authtoken = getCookie('hrwintoken');
    const url = `https://healthtrends-analytics.medibuddy.in/?accesstoken=${encodeURIComponent(authtoken)}`;

    return (
        <div style={{
            height: '95%',
            marginTop: '15px',
            marginLeft: '15px',
            marginRight: '10px',
        }}>
            <div style={{
                border: '1px solid black',
                height: '100%',
                borderRadius: '16px'
            }}>
                <iframe
                    src={url}
                    width="100%"
                    height="100%"
                    title="Health Trends Analytics"
                    frameBorder="0"
                    style={{
                        borderRadius: '16px'
                    }}
                ></iframe>
            </div>
        </div>
    );
}

export default HealthTrendsDashboard;
